import { StandardStrapiFields } from '../strapi/strapi'
import { CancelationReasons } from './print-job'
import RewindJobExecutor from './rewind-job-executor'
import RewindQueueEntry from './rewind-queue-entry'
import Shipment from './shipment'
import User from './user'

export default interface RewindJob extends StandardStrapiFields {
    assigned_by?: User
    assignedAt?: string
    jobStatus?: RewindJobStatuses | string
    cancelationReason?: CancelationReasons
    otherCancelationReason?: string
    approved_by?: User
    approvedAt?: string
    rewind_job_executors?: RewindJobExecutor[]
    rewind_queue_entries?: RewindQueueEntry[]
    shipment?: Shipment
    copies?: number | null // тираж части; пусто у старых заданий — весь тираж отгрузки
}

export enum RewindJobStatuses {
    Created = 'Создан',
    Planned = 'Добавлен в план',
    Rewinding = 'Перемотка',
    Completed = 'Завершен',
    Cancelled = 'Отменен',
}
